import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { getMerchantInfo } from '@util'
import 'antd4/lib/grid/style/index.css'
import React, { Component } from 'react'
import Planner from '../Planner'

const FormItem = Form.Item

class PlanField extends Component {
  render() {
    const { getFieldDecorator, formItemLayout, form_default } = this.props
    const top_wedding = !!+getMerchantInfo().top_wedding

    return (
      <>
        {top_wedding && (
          <FormItem label="策划师" {...formItemLayout}>
            {getFieldDecorator('person_id', {
              initialValue: form_default.person_id || undefined
            })(<Planner type="planner" />)}
          </FormItem>
        )}
      </>
    )
  }
}

export default PlanField
